export default function MySQL_NULL() {
  return (
    <div>
      <h2>MySQL_NULL</h2>    </div>
  );
}